"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortSuperSegments = exports.normaliseArrayOfSuperSegments = exports.normaliseArrayOfObjects = exports.arrayToObject = void 0;

var _helpers = require("../../helpers");

var arrayToObject = function arrayToObject(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  return array.reduce(function (obj, item) {
    obj[item[key]] = item;
    return obj;
  }, {});
}; // export const arrayOfObjectsOrder = (
//   array: Array<Object>,
//   key: string = 'id'
// ) => {
//   const order = [];
//   for (let i = 0; i < array.length; i++) {
//     order.push(array[i][key]);
//   }
//   return order;
// };


exports.arrayToObject = arrayToObject;

var normaliseArrayOfObjects = function normaliseArrayOfObjects(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  return {
    byId: arrayToObject(array, key),
    order: (0, _helpers.arrayOfObjectsOrder)(array, key)
  };
};

exports.normaliseArrayOfObjects = normaliseArrayOfObjects;

var normaliseArrayOfSuperSegments = function normaliseArrayOfSuperSegments(array, key) {
  if (key === void 0) {
    key = 'id';
  }

  return {
    bySlug: arrayToObject(array, key),
    order: (0, _helpers.arrayOfObjectsOrder)(array, key)
  };
};

exports.normaliseArrayOfSuperSegments = normaliseArrayOfSuperSegments;

var sortSuperSegments = function sortSuperSegments(superSegments) {
  Object.values(superSegments.bySlug).forEach(function (superSegment) {
    // $FlowFixMe
    superSegment.segments = superSegment.segments.sort(function (a, b) {
      return a.id - b.id;
    });
  });
  return superSegments;
};

exports.sortSuperSegments = sortSuperSegments;